<template functional>
  <div>
    <span
      v-if="
        props.column === 'DateEnd' &&
        $options.isOutdated(props.row[props.column], $options.actualDate)
      "
      class="outdated blink"
    >
      <i class="el-icon-time"></i>
      {{ $options.setFormatDate(props) }}
    </span>
    <span v-else-if="$options.formatDate(props.row[props.column])">
      <i class="el-icon-time"></i>
      {{ $options.setFormatDate(props) }}
    </span>
  </div>
</template>

<script>
import { formatDate } from "@/utils";

export default {
  name: "DatetimeFormatter",
  actualDate: new Date(),
  isOutdated(dueDate, today) {
    return new Date(dueDate) < today;
  },
  formatDate,
  setFormatDate(props) {
    const date = props.row[props.column];
    if (props.column == "Date") {
      return formatDate(date, "DD/MM/YYYY");
    }
    if (props.column == "fechaHora") {
      return formatDate(date, "DD/MM/YYYY hh:mm");
    }
    if (props.column == "fecha") {
      return formatDate(date, "DD/MM/YYYY hh:mm");
    }
    if (props["onlyDate"]) {
      return formatDate(date, "DD/MM/YYYY");
    }
    return formatDate(date, "DD/MM/YYYY");
  }
};
</script>

<style scoped>
.outdated {
  color: red;
}
.blink {
  animation: blink-animation 1s steps(5, start) infinite;
  -webkit-animation: blink-animation 1s steps(5, start) infinite;
}
@keyframes blink-animation {
  to {
    visibility: hidden;
  }
}
@-webkit-keyframes blink-animation {
  to {
    visibility: hidden;
  }
}
</style>
